{
  "schemaVersion": 1,
  "generatedAt": "2026-09-28T02:44:25.215Z",
  "rules": [
    {
      "id": "initial-2122e939ab6331e3",
      "manager": "npm",
      "match": {
        "format": 3,
        "file": "package-lock.json"
      },
      "range": ">=7.0.0",
      "knownBugs": [
        {
          "id": "npm-ci-lock-validation-4363",
          "range": ">=7.0.0 <8.4.1",
          "reason": "npm ci fails to reject manifest/lock dependency mismatches; valid lockfile graphs remain semantically compatible. Fixed in 8.4.1.",
          "url": "https://github.com/npm/cli/pull/4363"
        }
      ]
    },
    {
      "id": "initial-a62e8a2880674556",
      "manager": "npm",
      "match": {
        "format": 3,
        "file": "npm-shrinkwrap.json"
      },
      "range": ">=7.0.0 <12.0.0",
      "knownBugs": [
        {
          "id": "npm-ci-lock-validation-4363",
          "range": ">=7.0.0 <8.4.1",
          "reason": "npm ci fails to reject manifest/lock dependency mismatches; valid lockfile graphs remain semantically compatible. Fixed in 8.4.1.",
          "url": "https://github.com/npm/cli/pull/4363"
        }
      ]
    },
    {
      "id": "initial-899efb6fca864b12",
      "manager": "pnpm",
      "match": {
        "format": "9.0",
        "file": "pnpm-lock.yaml"
      },
      "range": ">=9.0.0"
    },
    {
      "id": "initial-cfa81a7e4f1c9078",
      "manager": "yarn",
      "match": {
        "format": 8,
        "classic": false,
        "file": "yarn.lock"
      },
      "range": ">=4.1.0 <4.14.0"
    },
    {
      "id": "initial-46b181875f19a566",
      "manager": "npm",
      "match": {
        "format": 1,
        "file": "package-lock.json"
      },
      "range": ">=5.7.0",
      "knownBugs": [
        {
          "id": "npm-ci-lock-validation-4363",
          "range": ">=7.0.0 <8.4.1",
          "reason": "npm ci fails to reject manifest/lock dependency mismatches; valid lockfile graphs remain semantically compatible. Fixed in 8.4.1.",
          "url": "https://github.com/npm/cli/pull/4363"
        }
      ]
    },
    {
      "id": "initial-fb24200a0bd8985b",
      "manager": "npm",
      "match": {
        "format": 2,
        "file": "package-lock.json"
      },
      "range": ">=5.7.0",
      "knownBugs": [
        {
          "id": "npm-ci-lock-validation-4363",
          "range": ">=7.0.0 <8.4.1",
          "reason": "npm ci fails to reject manifest/lock dependency mismatches; valid lockfile graphs remain semantically compatible. Fixed in 8.4.1.",
          "url": "https://github.com/npm/cli/pull/4363"
        }
      ]
    },
    {
      "id": "initial-68462c2f87a62230",
      "manager": "pnpm",
      "match": {
        "format": "5.4",
        "file": "pnpm-lock.yaml"
      },
      "range": ">=3.0.0 <8.0.0",
      "knownBugs": [
        {
          "id": "pnpm-auto-import-5.17.0",
          "range": "5.17.0",
          "reason": "In our macOS tests, pnpm 5.17.0 exits successfully without linking dependencies in auto/clone mode. The unchanged CLI succeeds with copy or hardlink; 5.17.1 also passes the tested fixture. The exact upstream issue and underlying cause remain unconfirmed.",
          "url": "https://github.com/pnpm/pnpm/compare/v5.17.0...v5.17.1"
        }
      ]
    },
    {
      "id": "initial-eb5697865755b60f",
      "manager": "pnpm",
      "match": {
        "format": "6.0",
        "file": "pnpm-lock.yaml"
      },
      "range": ">=7.24.0 <10.0.0",
      "knownBugs": [
        {
          "id": "pnpm-frozen-rewrite-6158",
          "range": ">=7.28.0 <7.30.1",
          "reason": "A known frozen-install bug reserializes an unchanged lockfile; semantic format compatibility is retained.",
          "url": "https://github.com/pnpm/pnpm/issues/6158"
        },
        {
          "id": "pnpm-v6-frozen-rejection-7934",
          "range": ">=9.0.0 <9.0.1",
          "reason": "The reader explicitly accepts lockfile 6, but the frozen-install full-resolution guard incorrectly rejects it; fixed in pnpm 9.0.1.",
          "url": "https://github.com/pnpm/pnpm/issues/7934"
        },
        {
          "id": "pnpm-v6-frozen-upgrade-7991",
          "range": "9.0.5",
          "reason": "pnpm 9.0.5 upgrades lockfile 6 to 9 even with --frozen-lockfile; the locked dependency graph and integrity are preserved. Fixed in 9.0.6.",
          "url": "https://github.com/pnpm/pnpm/issues/7991"
        }
      ]
    },
    {
      "id": "initial-be24049ae7b6e98c",
      "manager": "npm",
      "match": {
        "format": 2,
        "file": "npm-shrinkwrap.json"
      },
      "range": ">=5.7.0 <12.0.0",
      "knownBugs": [
        {
          "id": "npm-ci-lock-validation-4363",
          "range": ">=7.0.0 <8.4.1",
          "reason": "npm ci fails to reject manifest/lock dependency mismatches; valid lockfile graphs remain semantically compatible. Fixed in 8.4.1.",
          "url": "https://github.com/npm/cli/pull/4363"
        }
      ]
    },
    {
      "id": "initial-a3c5c5d1f160a4af",
      "manager": "npm",
      "match": {
        "format": 1,
        "file": "npm-shrinkwrap.json"
      },
      "range": ">=5.7.0 <12.0.0",
      "knownBugs": [
        {
          "id": "npm-ci-lock-validation-4363",
          "range": ">=7.0.0 <8.4.1",
          "reason": "npm ci fails to reject manifest/lock dependency mismatches; valid lockfile graphs remain semantically compatible. Fixed in 8.4.1.",
          "url": "https://github.com/npm/cli/pull/4363"
        }
      ]
    },
    {
      "id": "initial-435c73bcef1ac5a0",
      "manager": "pnpm",
      "match": {
        "format": "5.1",
        "file": "pnpm-lock.yaml"
      },
      "range": ">=3.0.0 <8.0.0",
      "knownBugs": [
        {
          "id": "pnpm-frozen-rewrite-6158",
          "range": ">=7.28.0 <7.30.1",
          "reason": "A known frozen-install bug reserializes an unchanged lockfile; semantic format compatibility is retained.",
          "url": "https://github.com/pnpm/pnpm/issues/6158"
        },
        {
          "id": "pnpm-auto-import-5.17.0",
          "range": "5.17.0",
          "reason": "In our macOS tests, pnpm 5.17.0 exits successfully without linking dependencies in auto/clone mode. The unchanged CLI succeeds with copy or hardlink; 5.17.1 also passes the tested fixture. The exact upstream issue and underlying cause remain unconfirmed.",
          "url": "https://github.com/pnpm/pnpm/compare/v5.17.0...v5.17.1"
        }
      ]
    },
    {
      "id": "initial-fa678480998594da",
      "manager": "pnpm",
      "match": {
        "format": "5",
        "file": "pnpm-lock.yaml"
      },
      "range": ">=3.0.0 <8.0.0",
      "knownBugs": [
        {
          "id": "pnpm-frozen-rewrite-6158",
          "range": ">=7.28.0 <7.30.1",
          "reason": "A known frozen-install bug reserializes an unchanged lockfile; semantic format compatibility is retained.",
          "url": "https://github.com/pnpm/pnpm/issues/6158"
        },
        {
          "id": "pnpm-auto-import-5.17.0",
          "range": "5.17.0",
          "reason": "In our macOS tests, pnpm 5.17.0 exits successfully without linking dependencies in auto/clone mode. The unchanged CLI succeeds with copy or hardlink; 5.17.1 also passes the tested fixture. The exact upstream issue and underlying cause remain unconfirmed.",
          "url": "https://github.com/pnpm/pnpm/compare/v5.17.0...v5.17.1"
        }
      ]
    },
    {
      "id": "initial-3629a2c96a7863c4",
      "manager": "pnpm",
      "match": {
        "format": "5.2",
        "file": "pnpm-lock.yaml"
      },
      "range": ">=3.0.0 <8.0.0",
      "knownBugs": [
        {
          "id": "pnpm-frozen-rewrite-6158",
          "range": ">=7.28.0 <7.30.1",
          "reason": "A known frozen-install bug reserializes an unchanged lockfile; semantic format compatibility is retained.",
          "url": "https://github.com/pnpm/pnpm/issues/6158"
        },
        {
          "id": "pnpm-auto-import-5.17.0",
          "range": "5.17.0",
          "reason": "In our macOS tests, pnpm 5.17.0 exits successfully without linking dependencies in auto/clone mode. The unchanged CLI succeeds with copy or hardlink; 5.17.1 also passes the tested fixture. The exact upstream issue and underlying cause remain unconfirmed.",
          "url": "https://github.com/pnpm/pnpm/compare/v5.17.0...v5.17.1"
        }
      ]
    },
    {
      "id": "initial-06533e6fb5473ab9",
      "manager": "pnpm",
      "match": {
        "format": "5.3",
        "file": "pnpm-lock.yaml"
      },
      "range": ">=3.0.0 <8.0.0",
      "knownBugs": [
        {
          "id": "pnpm-auto-import-5.17.0",
          "range": "5.17.0",
          "reason": "In our macOS tests, pnpm 5.17.0 exits successfully without linking dependencies in auto/clone mode. The unchanged CLI succeeds with copy or hardlink; 5.17.1 also passes the tested fixture. The exact upstream issue and underlying cause remain unconfirmed.",
          "url": "https://github.com/pnpm/pnpm/compare/v5.17.0...v5.17.1"
        }
      ]
    },
    {
      "id": "initial-22bef0f10c3fee2f",
      "manager": "yarn",
      "match": {
        "format": 4,
        "classic": false,
        "file": "yarn.lock"
      },
      "range": ">=2.3.0 <3.0.0"
    },
    {
      "id": "initial-3dd3f3c1a85d62d2",
      "manager": "yarn",
      "match": {
        "format": 10,
        "classic": false,
        "file": "yarn.lock"
      },
      "range": ">=4.15.0"
    },
    {
      "id": "initial-9a972bebee06ffaf",
      "manager": "yarn",
      "match": {
        "format": 6,
        "classic": false,
        "file": "yarn.lock"
      },
      "range": ">=3.2.0 <4.0.0"
    },
    {
      "id": "initial-8d770bc5dfb3a518",
      "manager": "yarn",
      "match": {
        "format": 9,
        "classic": false,
        "file": "yarn.lock"
      },
      "range": ">=4.14.0 <4.15.0"
    },
    {
      "id": "initial-7074b185fe58b248",
      "manager": "yarn",
      "match": {
        "format": 5,
        "classic": false,
        "file": "yarn.lock"
      },
      "range": ">=3.1.0 <3.2.0"
    },
    {
      "id": "initial-755295d8f39980f7",
      "manager": "pnpm",
      "match": {
        "format": "3",
        "file": "shrinkwrap.yaml",
        "features": {
          "sharedWorkspace": false
        }
      },
      "range": ">=1.41.1 <3.0.0"
    },
    {
      "id": "initial-90a26009865d9537",
      "manager": "pnpm",
      "match": {
        "format": "4",
        "file": "shrinkwrap.yaml",
        "features": {
          "sharedWorkspace": true
        }
      },
      "range": ">=2.17.2 <3.0.0"
    },
    {
      "id": "policy-yarn-classic-v1",
      "manager": "yarn",
      "match": {
        "file": "yarn.lock",
        "format": 1,
        "classic": true
      },
      "range": ">=0.21.0 <2.1.0"
    },
    {
      "id": "policy-yarn-modern-v7",
      "manager": "yarn",
      "match": {
        "file": "yarn.lock",
        "format": 7,
        "classic": false
      },
      "range": "<0.0.0"
    }
  ],
  "observations": []
}
